import React from 'react'
import { Link } from 'react-router-dom'

const Setting = () => {
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Profile Settings</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Profile Settings</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs" id="mainTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#profilesettings">
                                        <i className="bx bx-user" /> Profile Settings
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" data-bs-toggle="tab" data-bs-target="#subscription">
                                        <i className="bx bx-dollar" /> Subscription
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" data-bs-toggle="tab" data-bs-target="#organization">
                                        <i className="bx bx-buildings" /> Club Info
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" data-bs-toggle="tab" data-bs-target="#documents">
                                        <i className="bx bx-file" /> Documents
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" data-bs-toggle="tab" data-bs-target="#password">
                                        <i className="bx bx-lock" /> Password Settings
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content mt-4">
                                <div className="tab-pane fade show active" id="profilesettings" role="tabpanel">
                                    <div className="row mt-4">
                                        <div className="col-lg-4">
                                            <div className="card">
                                                <div className="card-body text-center">
                                                    <img src="images/avatars/avatar-2.png" className="rounded-circle p-1 bg-primary" width={120} />
                                                    <h4 className="mt-3">Emma Johnson</h4>
                                                    <p className="text-muted mb-2">Sporting complex</p>
                                                    <div className="upload_profile position-relative d-inline-block">
                                                        <input type="file" className="position-absolute opacity-0 w-100 h-100" />
                                                        <span className="btn btn-primary">Upload Photo</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">Full Name</label>
                                                        <div className="col-sm-8">
                                                            <input type="text" className="form-control" defaultValue="Emma Johnson" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">Role</label>
                                                        <div className="col-sm-8">
                                                            <input type="text" className="form-control" defaultValue="Coach" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">Mobile Number</label>
                                                        <div className="col-sm-8">
                                                            <input type="text" className="form-control" defaultValue={+1234567890} />
                                                        </div>
                                                    </div>
                                                    <button className="btn btn-primary d-block ms-auto">Edit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="subscription" role="tabpanel">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="card mt-4">
                                                <div className="card-header bg-transparent">
                                                    <strong>Subscription</strong>
                                                </div>
                                                <div className="card-body">
                                                    <div className="mb-2 d-flex justify-content-between">
                                                        <span className="text-muted">Plan</span>
                                                        <strong>Pro</strong>
                                                    </div>
                                                    <div className="mb-2 d-flex justify-content-between">
                                                        <span className="text-muted">Type</span>
                                                        <strong>Monthly</strong>
                                                    </div>
                                                    <div className="mb-2 d-flex justify-content-between">
                                                        <span className="text-muted">Subscribed On</span>
                                                        <strong>12 Aug 2025</strong>
                                                    </div>
                                                    <div className="mb-3 d-flex justify-content-between">
                                                        <span className="text-muted">Next Recharge</span>
                                                        <strong>12 Sep 2025</strong>
                                                    </div>
                                                    <div className="mb-3">
                                                        <span className="badge bg-success">Active</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="two_btns">
                                                <Link to="" data-bs-toggle="modal" data-bs-target="#upgrade_plan_modal" className="btn btn-secondary">Upgrade</Link>
                                                <Link to="" className="btn btn-primary">Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="organization" role="tabpanel">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">Upload Club Badge</label>
                                                        <div className="col-sm-8">
                                                            <input type="file" className="form-control" accept="image/*" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">Country</label>
                                                        <div className="col-sm-8">
                                                            <input type="text" className="form-control" defaultValue="USA" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">City</label>
                                                        <div className="col-sm-8">
                                                            <input type="text" className="form-control" defaultValue="New York" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">State</label>
                                                        <div className="col-sm-8">
                                                            <input type="text" className="form-control" defaultValue="N/Y" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">Club Type</label>
                                                        <div className="col-sm-8">
                                                            <select className="form-select">
                                                                <option selected>Soccer Club</option>
                                                                <option>Football Club</option>
                                                                <option>Athletics Club</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label className="col-sm-4 col-form-label">Club Name</label>
                                                        <div className="col-sm-8">
                                                            <select className="form-select">
                                                                <option selected>Brooklyn Strikers</option>
                                                                <option>Liberty United FC</option>
                                                                <option>London Royals</option>
                                                                <option>Manchester Titans</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <button className="btn btn-primary d-block ms-auto">Edit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="documents" role="tabpanel">
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="card mb-4 shadow-sm">
                                                <div className="card-header bg-transparent">
                                                    <strong>Documents</strong>
                                                    <small className="text-muted d-block">Upload required certificates</small>
                                                </div>
                                                <div className="card-body">
                                                    <div className="doc-row mb-4 d-flex align-items-center justify-content-between">
                                                        <div className="doc-left flex-grow-1 pe-3">
                                                            <label className="form-label fw-semibold mb-1">
                                                                Background Check Certificate
                                                            </label>
                                                            <small className="text-muted d-block mb-2">
                                                                Upload a valid background verification document
                                                            </small>
                                                            <input type="file" className="form-control" accept="image/*,.pdf" onchange="previewDoc(event, 'preview_bg')" />
                                                        </div>
                                                        <div className="doc-right image_doc_text text-center pe-3">
                                                            <p>Front Side</p>
                                                            <img src="images/cert.png" id="preview_bg" className="doc-thumb" />
                                                        </div>
                                                        <div className="doc-right image_doc_text text-center">
                                                            <p>Back Side</p>
                                                            <img src="images/DL2.png" id="preview_bg" className="doc-thumb" />
                                                        </div>
                                                    </div>
                                                    <div className="doc-row mb-4 d-flex align-items-center justify-content-between">
                                                        <div className="doc-left flex-grow-1 pe-3">
                                                            <label className="form-label fw-semibold mb-1">
                                                                Membership Certificate
                                                            </label>
                                                            <small className="text-muted d-block mb-2">
                                                                Organization or association membership proof
                                                            </small>
                                                            <input type="file" className="form-control" accept="image/*,.pdf" onchange="previewDoc(event, 'preview_membership')" />
                                                        </div>
                                                        <div className="doc-right image_doc_text text-center pe-3">
                                                            <p>Front Side</p>
                                                            <img src="images/cert.png" id="preview_membership" className="doc-thumb" />
                                                        </div>
                                                        <div className="doc-right image_doc_text text-center">
                                                            <p>Back Side</p>
                                                            <img src="images/DL2.png" id="preview_bg" className="doc-thumb" />
                                                        </div>
                                                    </div>
                                                    <div className="doc-row mb-4 d-flex align-items-center justify-content-between">
                                                        <div className="doc-left flex-grow-1 pe-3">
                                                            <label className="form-label fw-semibold mb-1">
                                                                National ID / License
                                                            </label>
                                                            <small className="text-muted d-block mb-2">
                                                                Government issued ID or license
                                                            </small>
                                                            <input type="file" className="form-control" accept="image/*,.pdf" onchange="previewDoc(event, 'preview_id')" />
                                                        </div>
                                                        <div className="doc-right image_doc_text text-center pe-3">
                                                            <p>Front Side</p>
                                                            <img src="images/cert.png" id="preview_id" className="doc-thumb" />
                                                        </div>
                                                        <div className="doc-right image_doc_text text-center">
                                                            <p>Back Side</p>
                                                            <img src="images/DL2.png" id="preview_bg" className="doc-thumb" />
                                                        </div>
                                                    </div>
                                                    <button className="btn btn-primary d-block ms-auto">
                                                        Upload Documents
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="password" role="tabpanel">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="mb-3">
                                                        <label className="mb-2">Current Password</label>
                                                        <input type="text" className="form-control" />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="mb-2">New Password</label>
                                                        <input type="password" className="form-control" />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="mb-2">Confirm Password</label>
                                                        <input type="password" className="form-control" />
                                                    </div>
                                                    <button className="btn btn-primary d-block ms-auto">Update Password</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="upgrade_plan_modal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div>
                                <h5 className="modal-title">flexible plans that grow with you</h5>
                                <p>with 0% commission fees</p>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-4 col-md-4">
                                    <div className="package_box">
                                        <h3>Free Trial <span>1 Month</span></h3>
                                        <h4>-</h4>
                                        <ul>
                                            <li>Create and manage games</li>
                                            <li>Assign referees</li>
                                            <li>Access to basic game management features</li>
                                        </ul>
                                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Select</button>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="package_box">
                                        <h3>Basic <span>Monthly</span></h3>
                                        <h4>$300</h4>
                                        <ul>
                                            <li>Create up to 5 games</li>
                                            <li>Reduced platform fee per game</li>
                                            <li>Standard game visibility</li>
                                        </ul>
                                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Select</button>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="package_box">
                                        <h3>Premium <span>Yearly</span></h3>
                                        <h4>$999</h4>
                                        <ul>
                                            <li>Unlimited game creation</li>
                                            <li>Lowest platform fee per game</li>
                                            <li>Game visibility boost (priority listing for referees)</li>
                                        </ul>
                                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Select</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Setting